import { NavLink } from 'react-router-dom';
import styled, { css } from 'styled-components';

import AquaLogo from 'assets/aqua/aqua-logo-text.svg';

import { commonMaxWidth, respondDown } from 'styles/mixins';
import {
    Breakpoints,
    COLORS,
    HEADER_HEIGHT,
    HEADER_HEIGHT_MOBILE,
    Z_INDEX,
} from 'styles/style-constants';

export const Container = styled.header`
    ${commonMaxWidth};
    width: 100%;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    height: ${HEADER_HEIGHT};
    padding: 0 4rem;
    z-index: ${Z_INDEX.header};
    background: ${COLORS.pageBackground};

    ${respondDown(Breakpoints.md)`
        height: ${HEADER_HEIGHT_MOBILE};
        padding: 0 1.6rem;
        z-index: ${Z_INDEX.accountMenu}
    `}
`;

export const Aqua = styled(AquaLogo)`
    height: 4.4rem;
    color: ${COLORS.textPrimary};

    ${respondDown(Breakpoints.md)`
        height: 3.4rem;
    `}
`;

export const linkStyles = css`
    text-decoration: none;
    font-size: 1.6rem;
    line-height: 2.4rem;
    white-space: nowrap;

    &:hover {
        color: ${COLORS.purple500} !important;
    }
`;

export const NavLinkStyled = styled(NavLink)<{ $disabled?: boolean }>`
    color: ${({ $disabled }) => ($disabled ? COLORS.textGray : COLORS.textPrimary)}!important;
    font-weight: ${({ $disabled }) => ($disabled ? '400!important' : 'unset')};
    ${linkStyles};

    &:not(:last-child) {
        margin-right: 2.4rem;
    }

    ${respondDown(Breakpoints.lg)`
        margin-right: 1rem;
    `}
`;

export const NavLinkWithCount = styled.div`
    display: flex;
    align-items: center;
    gap: 0.8rem;
    margin-bottom: 1.2rem;

    a {
        margin: 0 !important;
    }

    ${respondDown(Breakpoints.md)`
        margin-bottom: 2.4rem;
    `}
`;

export const Divider = styled.div`
    height: 2.4rem;
    width: 0;
    border-left: 0.1rem solid ${COLORS.gray100};
    margin: 0 2.4rem;

    ${respondDown(Breakpoints.lg)`
        margin-right: 1rem;
        height: 2rem;
    `};

    ${respondDown(Breakpoints.md)`
         border-left: none;
         height: 0;
         width: 20rem;
         margin: 2.4rem 0;
         border-top: 0.1rem solid ${COLORS.gray100};
    `};
`;

export const MainLink = styled(NavLink)`
    height: 4.4rem;

    ${respondDown(Breakpoints.md)`
        height: 3.4rem;
    `}
`;

export const NavLinks = styled.div`
    display: flex;
    padding: 1.6rem;
    align-items: center;

    a {
        color: ${COLORS.textPrimary};
        text-decoration: none;

        &:hover {
            color: ${COLORS.purple500};
        }

        &::before {
            content: attr(title);
            visibility: hidden;
            overflow: hidden;
            user-select: none;
            pointer-events: none;
            font-weight: 700;
            height: 0;
            display: block;
        }
    }

    ${respondDown(Breakpoints.xl)`
        a {
            &:not(:last-child) {
                margin-right: 2.2rem;
            }
        }
    `}

    ${respondDown(Breakpoints.lg)`
        a {
            &:not(:last-child) {
                margin-right: 2rem;
            }
        }
    `}

    ${respondDown(Breakpoints.md)`
        display: none;
    `}
`;

export const RightBlock = styled.div`
    display: flex;
    align-items: center;
`;

export const NotificationsSlot = styled.div`
    width: 5.6rem;
    min-width: 5.6rem;
    height: 4.8rem;
`;

export const MyAquarius = styled(NavLink)`
    display: flex;
    align-items: center;
    padding: 0 1.6rem;
    height: 4.8rem;
    background-color: ${COLORS.controlBackground};
    border: 0.1rem solid ${COLORS.controlBorder};
    border-radius: 0.6rem;
    cursor: pointer;
    font-size: 1.6rem;
    line-height: 2.4rem;
    color: ${COLORS.textPrimary};
    text-decoration: none;

    &:hover {
        background-color: ${COLORS.controlHover};
    }

    div::after {
        content: attr(title);
        visibility: hidden;
        overflow: hidden;
        user-select: none;
        pointer-events: none;
        font-weight: 700;
        height: 0;
        display: block;
    }

    svg {
        margin-right: 0.8rem;
        height: 1.6rem;
        width: 1.6rem;
    }

    &:hover {
        color: ${COLORS.purple500};
    }

    ${respondDown(Breakpoints.xl)`
        width: 4.8rem;
        div {
            display: none;
        }
        svg {
            margin-right: 0;
        }
    `}
`;
